window.Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.ShippingValidation = (function () {
  const requiredShippingField = '[data-required-shipping-rate]';
  const shippingEnabledField = '[data-bind=\'shipping-enabled\']';
  const shippingMatrix = '[data-bind=\'product-shipping-fields\']';
  const shippingMatrixInputs = `${shippingMatrix} input`;
  const localShippingCheckbox = '#product_shipping_local';
  const shippingRates = '[data-shipping-rate]';

  const shippingErrors = '.shipping-error';
  const shippingErrorSelectOne = '#shipping-choose';

  function isShippingEnabled() {
    return $(shippingEnabledField).is(':checked');
  }

  function handleShippingSelect() {
    $(shippingEnabledField).change(() => {
      enableShippingFields();
      validateShippingOptionPresent();
      requireShippingFields();
    });
    $(localShippingCheckbox).change((e) => {
      validateShippingOptionPresent();
    });
  }

  function bindShippingRateChange() {
    $(shippingRates).blur(() => {
      validateRequiredShippingRatePresent();
    });
  }

  function enableShippingFields() {
    $(shippingMatrixInputs).prop('disabled', !isShippingEnabled());
  }

  function requireShippingFields() {
    if (isShippingEnabled()) {
      $(requiredShippingField).prop('required', true);
    } else {
      $(requiredShippingField).prop('required', false);
    }
  }

  function setShippingOnLoad() {
    enableShippingFields();
    showHideShippingMatrix();
    requireShippingFields();
  }

  function showHideShippingMatrix() {
    const shippingMatrixElement = $(shippingMatrix);
    if (isShippingEnabled()) {
      shippingMatrixElement.show();
    } else {
      shippingMatrixElement.hide();
    }
  }

  function isLocalPickupEnabled() {
    return $(localShippingCheckbox).is(':checked');
  }

  function isRequiredRateFieldPresent() {
    // If val returns undefined, the field is not present.
    if (!$(requiredShippingField).val()) {
      return false;
    }

    return ($(requiredShippingField).val().length != 0);
  }

  function unrequireShippingFields() {
    $(shippingMatrixInputs).removeAttr('required');
  }

  function validateRequiredShippingRatePresent() {
    let valid = true;

    $(requiredShippingField).removeClass('ui-state-error');

    if (isShippingEnabled() && !isRequiredRateFieldPresent()) {
      $(requiredShippingField).addClass('ui-state-error');
      valid = false;
    }

    return valid;
  }

  function validateShippingOptionPresent() {
    let valid = true;

    $(shippingErrorSelectOne).hide();
    $(requiredShippingField).removeClass('ui-state-error');

    if (!(isShippingEnabled() || isLocalPickupEnabled())) {
      $(shippingErrorSelectOne).fadeIn();
      valid = false;
    }

    return valid;
  }

  function init() {
    handleShippingSelect();
    bindShippingRateChange();
    setShippingOnLoad();
  }

  return {
    init,
  };
}());

$(document).ready(() => {
  Reverb.Listing.ShippingValidation.init();
});
